import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_FlowSheet } from '@app/advisor-content-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onFlowSheetsUpdated = new ThunderDispatcherV3('__onFlowSheetsUpdated');
export class ModuleFE_FlowSheet_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_FlowSheet, dispatch_onFlowSheetsUpdated);
        this._v1 = {};
    }
    // ######################## Search ########################
    __searchFilterMapper = (item) => [item.label, item._id];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey,
                results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label,
                }))
            }];
    };
}
export const ModuleFE_FlowSheet = new ModuleFE_FlowSheet_Class();
//# sourceMappingURL=ModuleFE_FlowSheet.js.map